// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__2K4qQ","header":"ReportDetails_header__14JHf","title":"ReportDetails_title__3xs4Q","left":"ReportDetails_left__3lRYe"};